export default "/images/vendor/flag-icons/flags/1x1/nr.svg?8ccd0a5da4e0df47f13dc9a61cb16790";